import React from 'react';
import { connect } from 'react-redux';
import { translate } from '../../base/i18n/functions';
import { AbstractWelcomePage, _mapStateToProps } from './AbstractWelcomePage';
/**
 * Shows why the CAS login failed. The user closes it and logs in again from the welcome page,
 * where CAS always asks for the credentials (see startSSOLogin).
 */
class LoginErrorPopup extends AbstractWelcomePage {
    /**
     * Closes the popup.
     *
     * @returns {void}
     */
    _onClose = () => {
        this.props.closePopup();
    };
    render() {
        const { code, labelPrefix, title, t } = this.props;
        return (React.createElement("div", { className: 'modal' },
            React.createElement("div", { className: 'modal-content' },
                React.createElement("span", { className: 'close', onClick: this._onClose }, " \u00D7 "),
                React.createElement("h1", { className: 'testoPopup' },
                    " ",
                    title,
                    " "),
                React.createElement("h4", { className: 'testoPopup' },
                    " ",
                    t(`${labelPrefix}.${code}`, { defaultValue: t(`${labelPrefix}.erroreGenerico`) }),
                    " "))));
    }
}
export default translate(connect(_mapStateToProps)(LoginErrorPopup));
